export default "__VITE_ASSET__D9MN2AsS__"